"use client";
import {
  createElement,
  createHook,
  forwardRef
} from "./GWSL6KNJ.js";

// src/separator/separator.tsx
var TagName = "hr";
var useSeparator = createHook(
  function useSeparator2({ orientation = "horizontal", ...props }) {
    props = {
      role: "separator",
      "aria-orientation": orientation,
      ...props
    };
    return props;
  }
);
var Separator = forwardRef(function Separator2(props) {
  const htmlProps = useSeparator(props);
  return createElement(TagName, htmlProps);
});

export {
  useSeparator,
  Separator
};
